import { render, staticRenderFns } from "./Related.vue?vue&type=template&id=3f9f6ccd&scoped=true"
import script from "./Related.vue?vue&type=script&lang=js"
export * from "./Related.vue?vue&type=script&lang=js"
import style0 from "./Related.vue?vue&type=style&index=0&id=3f9f6ccd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9f6ccd",
  null
  
)

export default component.exports